import { useCallback } from 'react'
import { usePolling } from '../hooks/usePolling'
import { partyApi, PartyList } from '../lib/api'

export default function HistoryPage() {
  const fetcher = useCallback(() => partyApi.list({ status: 'ended', role: 'admin', limit: '50' }), [])
  const { data, loading, error } = usePolling<PartyList>({ fetcher, interval: 30000 })

  const parties = data?.parties ?? []

  if (loading) {
    return (
      <div className="space-y-4">
        <h1 className="text-2xl font-bold text-gray-900">Party History</h1>
        <div className="bg-white shadow rounded-lg p-6 animate-pulse">
          <div className="h-4 bg-gray-200 rounded w-1/4 mb-4"></div>
          <div className="space-y-3">
            {[...Array(3)].map((_, i) => (
              <div key={i} className="h-4 bg-gray-200 rounded"></div>
            ))}
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-bold text-gray-900">Party History</h1>

      {error && (
        <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-md text-sm">
          Failed to load history. Retrying...
        </div>
      )}

      {parties.length === 0 ? (
        <div className="text-center py-12">
          <p className="text-gray-500">No ended parties yet</p>
        </div>
      ) : (
        <div className="bg-white shadow rounded-lg overflow-hidden">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Name</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Code</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Participants</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Created</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Ended</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {parties.map((party) => (
                <tr key={party.id}>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{party.name}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-mono text-gray-500">{party.code}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{party.participant_count}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    {new Date(party.created_at).toLocaleDateString()}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    {party.ended_at ? new Date(party.ended_at).toLocaleDateString() : '-'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  )
}
